import React from 'react';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../form';
import LoginForm from '../../login';
import ReceptionLoginForm from './ReceptionLoginForm';
import attemptReceptionLogin from './attemptReceptionLogin';
import schema from './schema';

export const ReceptionLoginPage: React.FC = () => (
  <Container>
    <Well>
      <FormHeading title="Reception Login" backPath="/" />
      <LoginForm
        initialValues={{ pin: '', password: '' }}
        validationSchema={schema}
        promise={attemptReceptionLogin}
        redirectPath="/reception"
      >
        <ReceptionLoginForm />
      </LoginForm>
    </Well>
  </Container>
);
